import axios from 'axios'
import {BUSCAR_AGENCIAS_EMPRESA} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarAgenciaEmpresa(idEmpresa) {
    
    const url = `${URL}/agencia/empresa/${idEmpresa}/agencias`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_AGENCIAS_EMPRESA,
            payload: response

        })
    );
}
